import { Box, Flex, Heading } from "@chakra-ui/react";
import ServiceCard from "./ServiceCard";
import { BsDisplay, BsPhone, BsFeather } from "react-icons/bs";

export default function Services() {
  const services = [
    {
      title: "Web app development",
      icon: BsDisplay,
    },
    {
      title: "Mobile app development",
      icon: BsPhone,
    },
    {
      title: "UI/UX design",
      icon: BsFeather,
    },
  ];

  return (
    <Box width={"full"} textAlign={"center"}>
      <Heading size={"lg"}>What I do</Heading>
      <Flex
        marginTop={6}
        justifyContent={"center"}
        wrap={"wrap"}
        alignItems={"stretch"}
        gap={6}
      >
        {services.map((service: any, index: number) => (
          <ServiceCard
            key={`service-${index}`}
            width={{ base: "100%", md: "33.33%", lg: "calc(25% - 1.5rem)" }}
            service={service}
          />
        ))}
      </Flex>
    </Box>
  );
}
